import { observable, toJS } from 'mobx';

import hasSameValues from '../functions/hasSameValues';


export default function createAnyField({ 
    name,
    value = null,
}, form) {
    if (!name) {
        throw new Error('[createAnyField] requires a name');
    }

    return observable({
        name,
        value,

        form,

        lastUpdated: null,

        get id() {
            return this.name;
        },

        get typedValue() {
            return toJS(this.value);
        },

        isValid: true,

        setName(name) {
            this.name = name;
        },

        setValue(value) {
            // Only update if ACTUALLY different; can prevent infinite re-renders
            if (!hasSameValues(value, this.typedValue)) {
                this.value = value;
            }

            this.lastUpdated = Date.now();
        },

        setForm(form) {
            this.form = form;
        },

        // APIs we need to handle invocations from useFormState; but don't use
        setTouched() {},
    }, undefined, { name: `AnyField("${name}")` });
}